import { createAction } from '@reduxjs/toolkit'
import { actions } from 'apps/builder/store/reducers/importData'

export const {
  setForms,
  setPotentialFormData,
  setLoading,
  clearPotentialFormData,
  toggleSheets,
  toggleSheet,
  toggleImportSelected,
  toggleImportSheet,
  removePotentialEntry,
  removePotentialSheet,
  updatePotentialEntry,
  updatePotentialSheet
} = actions

export const importFormData = createAction('importData/importFormData')
